import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import Typography from 'aquilla/core/atoms/Typography';
import Image from '@base/Image';
import useCertificationCourseData from './useCertificationCourseData';

const Container = styled.div`
  width: 100%;
  ${mediaQuery.uptoMobile} {
    overflow: hidden;
  }
`;

const Title = styled(Typography)``;

const CaseStudiesWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${Spacings.SPACING_6B};
  margin-top: ${Spacings.SPACING_6B};
  ${mediaQuery.uptoMobile} {
    grid-template-columns: 1fr;
    gap: ${Spacings.SPACING_4B};
    margin-top: ${Spacings.SPACING_4B};
  }
`;

const CaseStudyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${Spacings.SPACING_6B};
  width: 372px;
  height: 232px;
  background: #ffffff;
  border: ${Spacings.SPACING_1} solid var(--color-divider);
  border-radius: ${Spacings.SPACING_2B};
  ${mediaQuery.uptoMobile} {
    width: 100%;
    padding: ${Spacings.SPACING_4B};
    height: auto;
  }
`;

const CaseStudyTitle = styled(Typography)`
  margin-top: ${Spacings.SPACING_4B};
  margin-bottom: ${Spacings.SPACING_2B};
`;

const CaseStudyDescription = styled(Typography)`
  ${mediaQuery.uptoMobile} {
    font-size: ${Fonts.ULTRA_SMALL};
    line-height: ${Spacings.SPACING_18};
  }
`;

const ImageWrapper = styled.div`
  width: 40px;
  height: 40px;
  min-height: 40px;
  position: relative;
`;

const CaseStudy = ({ caseStudies = [] }) => {
  if (!caseStudies?.length) return null;
  return (
    <CaseStudiesWrapper>
      {caseStudies?.map((caseStudy) => {
        return (
          <CaseStudyWrapper key={caseStudy.uid}>
            <ImageWrapper>
              <Image
                src="certificationCourses/printed-notes.svg"
                layout="fill"
                alt="printed-notes"
              />
            </ImageWrapper>
            <CaseStudyTitle variant="h5">
              {caseStudy.caseStudyTitle}
            </CaseStudyTitle>
            <CaseStudyDescription
              variant="p2"
              color="var(--color-text-primary)"
            >
              {caseStudy.caseStudyDescription}
            </CaseStudyDescription>
          </CaseStudyWrapper>
        );
      })}
    </CaseStudiesWrapper>
  );
};

const CaseStudies = ({ goalUID }) => {
  const { sections } = useCertificationCourseData(goalUID);
  const caseStudies = sections?.caseStudies ?? {};
  return (
    <Container>
      <Title variant="h3">
        {caseStudies.programmeCaseStudiesTitle || 'Case studies'}
      </Title>
      <CaseStudy caseStudies={caseStudies?.programmeCaseStudies} />
    </Container>
  );
};

export default CaseStudies;
